import React, { Component } from 'react';
import { Container, Navbar, NavbarBrand} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import RightMenu from './RightMenu';
import Cookies from 'js-cookie';
import Button from '@material-ui/core/Button';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

    render() {

        return (
            <header>
                {
                    window.location.pathname.toLowerCase() == '/signup' ||
                    window.location.pathname.toLowerCase() == '/signin' ||
                    window.location.pathname.toLowerCase() == '/findidpw' ||
                    window.location.pathname.toLowerCase().startsWith('/display') ||
                    window.location.pathname.toLowerCase().startsWith('/showcase')
                    ? (<div></div>) : (
                        <Navbar className="navbar-expand-md navbar-toggleable-md ng-white border-bottom box-shadow mb-5" light>
                            <Container>
                                <NavbarBrand tag={Link} to="/">
                                    <img alt="loading..." src={require('../images/logo_v1.1.png')} style={{ width: 100 }} />

                                    {window.location.hostname == '192.168.0.2' ?
                                        (
                                            <div style={{ display: 'inline' }}>
                                                {Cookies.get("LoginId")}님 환영합니다!
                                                    <Button variant="outlined" onClick={() => { document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); }); window.location.assign('/display/connected'); }} style={{ marginLeft:10 }}>
                                                    로그아웃
                                                </Button>
                                            </div>
                                        ) :
                                        (
                                            <div style={{ display: 'inline' }}>
                                                {Cookies.get("StoreName")}
                                            </div>
                                        )
                                    }
                                </NavbarBrand>
                                {/*<Chip
                            avatar={<Avatar>34</Avatar>}
                            label="18:23까지 이용가능"
                            color='primary'
                            variant="outlined"
                                />*/}
                                <RightMenu />
                            </Container>
                        </Navbar>
                    )}
            </header>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js